<template>
  <PublicColescbaApp app-container-classes="md:p-6" router-view-classes="container mx-auto xl:w-5/6" />
</template>

<script>
import { useColescba } from '@colescba/app-vue'

import { requestedServices } from '@/services'


export default {
  mixins: [useColescba({ env: process.env, requestedServices })],

  data() {
    return {}
  },


}
</script>
